import React, { useRef, useState, useEffect } from 'react'

import {
    Box,
    styled,
    Card,
    Button,
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import CommonBreadcumbs from '../../common/CommonBreadcumbs';

import DataGridRowActionMenu from '../../common/DataGridRowActionMenu';
import DataGridTable from '../../common/DataGridTable';
import DataGridToolbar from '../../common/DataGridToolbar';
import CommonRestricted from '../../common/CommonRestricted';
import { useAppContextFeatures } from '../../../context/AppContext'

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useTransactions, destinationTypes, targetTypes } from '../../../hooks/api/useTransactions';

import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { CommonIcons, icons } from "../../common/CommonIcons"
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';
import { useTranslations } from '../../../hooks/useTranslations';

const StyledCard = styled(Card)(({ theme }) => ({
    // padding: theme.spacing(3)
}));

export default function ListWalletTransactions({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "@transaction"] })

    const navigate = useNavigate();
    const { setSystemLoading } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { list } = useTransactions({ targetType: targetTypes.wallet });
    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay, getRenderColumnTextDisplay } = useDataGridParams('id')
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.transaction.id, scopeTypes.transaction.wallet.id)

    const [selectedIds, setSelectedIds] = useState([])
    const [refreshDataGrid, setRefreshDataGrid] = useState(0)
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const gridRef = useRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            const result = await list(props)

            console.log('Result', result?.data)

            return {
                data: result?.data?.transactions,
                count: result?.data?.nofilter_total
            }

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`)

            return {
                data: [],
                count: 0
            }
        }

    }

    useEffect(() => {

        defineColumnsView()

    }, [])

    const defineColumnsView = () => {
        defineColumns([

            {
                name: "transaction_no",
                header: t("transactionNo"),
                renderValue: ({ value, cellProps }) => {

                    if (isPermissionAllow({ functionType: functionTypes.pageView.id }) === false) {
                        return getRenderColumnTextDisplay(value)
                    }

                    let path = getRoute(`transaction/wallet/transaction/view/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value)

                }
            },
            {
                name: "transaction_amount",
                header: t("amount"),
                renderValue: ({ value, cellProps }) => {
                    return(
                        <>{parseFloat(value).toFixed(2)}</>
                    )
                }
            },
            {
                name: "transaction_status",
                header: t("status"),
            },
            {
                name: "description",
                header: t("description"),
            }
        ])
    }

    // const handleDelete = async () => {

    //     setSystemLoading(true)

    //     try {
    //         const result = await remove({ ids: selectedIds })

    //         promptMessage(true, result?.message)
    //         setRefreshDataGrid(val => val + 1)

    //         resetDataGridTableSelection();

    //     } catch (error) {
    //         promptMessage(false, error?.message)
    //     }

    //     setSystemLoading(false)

    // }

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {

                        navigate(getRoute("transactions/walletTransaction/new"));

                    }
                })
            }

            return props
        }

        // const getActionOnClick = () => {

        //     let handleFunction = null

        //     if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
        //         handleFunction = handleDelete
        //     }

        //     return handleFunction
        // }

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickRemove={
                    [] // getActionOnClick()
                }
                actionMenus={[]}
            />
        )
    }

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        // minHeight: 600
                    },
                    checkboxColumn: false,
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        )
                    }
                }}

            />
        )
    }

    return (
        <Box>

            {
                getHtmlHead({ routeType, title: t("walletTransactions") })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("walletTransactions")}
                breadcrumbs={[
                    {
                        displayText: t("walletTransactions"),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}
